import { Image } from '@yleisradio/areena-types';
import { ImageLoader, ImageLoaderProps } from 'next/image';
import { isTestEnvironment } from './environment';

const root = isTestEnvironment()
  ? 'https://img-test.img-cdn.yle.fi'
  : 'https://img.img-cdn.yle.fi';

export function loaderUrl(image: Image): string {
  return image.id;
}

export const defaultLoader: ImageLoader = ({ src, width, quality }) => {
  const params = [
    'crop_limit',
    `w_${width}`,
    ...(quality ? [`q_${quality}`] : []),
  ].join(',');
  return `${root}/${params}/${src}`;
};

export function fixedAspectRatioImageLoader(
  aspectRatio: '16:9' | '1:1' | '9:13'
): ImageLoader {
  return ({ src, width, quality }) => {
    const params = [
      'crop_fill',
      `ar_${aspectRatio}`,
      `w_${width}`,
      ...(quality ? [`q_${quality}`] : []),
    ].join(',');

    return `${root}/${params}/${src}`;
  };
}

export const squareImageLoader = fixedAspectRatioImageLoader('1:1');

export function backgroundImageLoader({
  aspectRatio,
  isBlurred,
}: {
  aspectRatio: '16:9' | '1:1';
  isBlurred: boolean;
}): ImageLoader {
  return ({ src, width, quality }: ImageLoaderProps): string => {
    const params = [
      'crop_fill',
      `ar_${aspectRatio}`,
      'focus_top',
      `w_${width}`,
      ...(quality ? [`q_${quality}`] : []),
      ...(isBlurred ? ['blur_60'] : []),
    ].join(',');
    return `${root}/${params}/${src}`;
  };
}

export function openGraphImageUrl(
  image: Image,
  ratio: '16:9' | '1:1' | undefined = '16:9'
): string {
  return `${root}/f_jpg,${
    ratio === '16:9' ? 'crop_fill' : 'crop_pad'
  },bg_gradient_dominant,w_1920,h_1080/${image.id}`;
}
